<template>
    <div :class="extendable ? 'premium--lock-down-extendable' : 'premium--lock-down'" v-if="!$IAP.hasAccessToComponent('smart')">
        <pm-premium-lock-screen-extend v-if="extendable" />

        <div v-if="!extendable" style="font-size: 18px; padding-top: 5px; text-align: center; color: #fff!important; font-weight: 600; line-height: 2;">

            <span style="border-radius: 10px; background: rgba(0,0,0,0); border: 0px solid #fff; display: inline-block; padding: 12px 12px 0px 12px; margin: 0 0 10px 0; ">

                <p style="text-shadow: 1px 1px 1px #000;line-height: 1.3; color: #fff; font-weight: 600;">Your free trial has expired.</p>
                <br/>
            </span>


            <div style="background-image: url('https://cdn.denticalc.com/images/unlock.png'); background-position: right; no-repeat; background-size: contain; line-height: 1.3; display: block; position: relative; font-size: 15px;">



                <div style="text-shadow: 1px 1px 1px #000, 1px 1px 10px #448; text-align:left; padding: 40px 0px 20px 20px; width: 90vw; max-width: 380px; font-weight: 900; font-size: 26px; line-height: 1.3; ">
                   <!-- <br/><mdi :size="60" style="color: #fff!important; margin: 0 0 16px -10px;">lock</mdi><br/> -->

                    I'm sure<br/>you loved
                    <br/>
                    using DentiCalc
                    <br/>
                    <u @click="subscribe" style="font-weight: 900; color: rgba(255,200,50);">Stay engaged!</u><br/>
                    <br/>
                </div>
            </div>

            <!-- <pm-premium-features-list-alt style="color: #fff; text-shadow: 1px 1px 1px #000;" v-if="productsLoaded" :price="fullPriceNum" :currency="currency" /> -->
            <pm-iap-product-button ref="product-button" style="color: #000; border-radius: 40px; margin: -20px auto 10px auto;" :referrer="'click_lock_screen_' + $router.currentRoute.name" arrow-color="#fff">
                <span slot="button-text" style="font-weight: 600; line-height: 1.3;">
                    <span style="text-shadow: 0 0 3px rgba(0,0,0,.5); font-weight: 900; font-size: 20px; color: #fff;">SUBSCRIBE NOW</span><br/>
                    <span style="text-shadow: 0 0 3px rgba(0,0,0,.5); font-weight: 600; font-size: 15px; color: #fff;"><small>only</small><span style="font-weight: 600"> {{origPrice}}</span><small> / month</small></span>
                </span>
            </pm-iap-product-button>
            <template v-if="productsLoaded">

                <div style="font-size: 22px; line-height: 1; margin-top: 10px;">
                    <!-- <span style="border-radius: 3px; box-shadow: inset 2px 2px 3px rgba(0, 0, 0, .2); background: #fff; display: inline-block; padding: 6px 12px; margin: 10px 0 0 0; ">
                        <h2 class="shimmer-dark" style="font-size: 36px; font-weight: 900; padding: 0; line-height: 1.2;">-90% OFFER</h2>
                    </span>
                    <br/> -->
                    <!-- <span style="border-radius: 3px; box-shadow: inset 2px 2px 3px rgba(0, 0, 0, .2); background: #fff; display: inline-block; padding: 0px 12px; margin: 10px 0 10px 0; ">
                        <h3 class="shimmer-dark" style="text-shadow: 2px 2px 2px rgba(0,0,0,.2);font-size: 28px; font-weight: 900; margin: 10px 0 10px 0; padding: 0;">SPECIAL OFFER</h3>
                    </span>
                    <br/> -->

                    <!-- <span style="text-shadow: 1px 1px 1px #000; font-weight: 300;"><small>Only</small><span style="font-weight: 900"> {{origPrice}}</span><small> / month</small></span>
                    <br/> -->
                    <!-- <div style="text-shadow: 1px 1px 1px #000; font-size: 12px; margin: 0 0 10px 0;">Includes ALL features:</div> -->
                    <!-- <pm-premium-features-list-alt style="color: #fff; text-shadow: 1px 1px 1px #000;" v-if="productsLoaded" :price="fullPriceNum" :currency="currency" /> -->

                </div>
            </template>

            <small style="text-shadow: 1px 1px 1px #000; font-size: 12px;">No risk, cancel anytime on <span v-if="$isIOS()">the App Store</span><span v-if="!$isIOS()">Google Play</span></small>
        </div>
    </div>
</template>
<style>

    .shimmer-dark {
        background: #000 -webkit-gradient(linear, 100% 0, 0 0, from(#000), color-stop(0.5, #ffaa07), to(#000));
        background-position: -12rem top; /*50px*/
        background-repeat: no-repeat;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        -webkit-animation-name: shimmer;
        -webkit-animation-duration: 2.2s;
        -webkit-animation-iteration-count: 1;
        -webkit-background-size: 14rem 100%; /*50px*/
    }

    .premium--lock-down-extendable {
        background: none!important;
    }

    .premium--lock-down-extendable:before {
        content: "";
        display: block;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: #0b2e02!important;
        background-image: url('https://cdn.denticalc.com/images/54955-2.jpg')!important;
        background-size: 100% auto!important;
        background-repeat: no-repeat!important;
        background-position: right bottom!important;
        opacity: .8;
        z-index: 0;
    }
    .premium--lock-down-extendable.focused:before {
        background-image: none!important;
    }

    #trial-extended-container {
        position: relative;
        z-index: 1;
    }

    .premium--lock-down,
    .premium--lock-down-extendable
     {
        z-index: 3;
        display: flex;
        justify-content: center;
        align-items: center;
        position: absolute;
        right: 0px;
        top: 0px;
        left: 0;
        bottom: 0;
        cursor: pointer;
        backdrop-filter: blur( 3px );
        -webkit-backdrop-filter: blur( 3px );
        background: rgba(0,40,140,.7);
        padding: 3px;
        border-radius: 3px;
    }

    .premium--lock-down .pm-btn-glowing:before,
    .premium--lock-down-extendable .pm-btn-glowing:before
    {
        border: 1px solid rgb(255, 255, 255);
    }

    @media (min-width: 700px) {
        .premium--lock-down,
        .premium--lock-down-extendable
        {
            --top-height: 52px;
            --bottom-height: 70px;
            height: calc(100vh - var(--top-height, 52px) - var(--bottom-height, 70px)) !important
        }
    }
</style>
<script>
import PmReviewsSlider from "@/components/dialogs/reviews-slider.vue";
/*
import PmPremiumLockScreen from "@/components/core/premium-lock-screen";
<pm-premium-lock-screen v-if="!$IAP.hasAccessToComponent('smart')" />
 */
import PmPremiumFeaturesListAlt  from "@/components/dialogs/premium-features-list-alt.vue";
import PmIapProductButton from "@/components/core/iap-product-button.vue";
import PmPremiumLockScreenExtend from "@/components/core/premium-lock-screen-extend";
import { trialMinutesLeft } from "@/utils/iap/trial-days";

export default {
    components: {
        PmReviewsSlider,
        PmIapProductButton,
        PmPremiumLockScreenExtend,
        PmPremiumFeaturesListAlt,
    },
    props: {
        trackLabel: {
            type: String,
            default: "",
        }
    },
    data: () => ({
        extendable: false,
        sku: "",
        productsLoaded: false,
        origPrice: 0,
        introPrice: 0,
        isPremiumUsed: true,
        fullPriceNum: 0,
        currency: "",
    }),
    created() {
        this.registerBusEvent('trialExtended', () => {
            this.extendable = false;
            this.$forceUpdate();
        });

        if (window.IAP.status.includes('offeringsLoaded')) {
            this.init();
        }
        this.$bus.$on("flutter:onOfferingsUpdated", () => {
            this.init();
        });
        if (window.IAP.status.includes('offeringsLoaded')) this.init();
        // this.$bus.$emit('openAppDialog','premium');
    },
    mounted() {
        this.extendable = (trialMinutesLeft() <= 0 && !localStorage.getItem('extendedTrial'));
        window.Tracker.logEvent({
            event_name: "premium_show",
            event_category: "iap",
            event_label: this.trackLabel === "" ? "lock_screen_" + app.$router.currentRoute.name : this.trackLabel,
        });
    },
    methods: {
        init() {
            this.getDefaultProduct();

            this.origPrice = IAP.getProductPrices(this.product);
            this.introPrice = IAP.getIntroPrice(this.product);
            // this.isPremiumUsed = this.sku !== "full_access_monthly_sale" || IAP.hasPreviousPurchase(this.sku);
            this.isPremiumUsed = true;

            this.productsLoaded = true;
        },
        getDefaultProduct() {
            this.sku = window.IAP.getDefaultSku();
            this.product = window.IAP.getProduct(this.sku);
            if (this.product === null) return;

            // if (this.product.currencyCode.toUpperCase() === "INR" || this.product.currencyCode.toUpperCase() === "HUF") {
                this.sku = IAP.getDefaultSku();
                this.product = IAP.getProduct(this.sku);
            // }

            this.fullPriceNum = this.getFullPrice(this.product);
            this.currency = this.product.currencyCode;
        },
        getFullPrice2(product) {
            const origPriceNum = IAP.getProductPrices(product, true);
            const hasDecimals = parseInt(origPriceNum) !== parseFloat(origPriceNum);
            const full = parseFloat((origPriceNum * 10).toFixed(2)) + 0;
            return hasDecimals ? full.toFixed(2) : full;
        },
        getFullPrice(product) {
            let hasDecimals = parseInt(product.priceAsString) !== parseFloat(product.priceAsString);
            const multiplier = 10;
            const full = parseFloat((parseFloat(product.priceAsString) * 10).toFixed(2)) + 0;
            return hasDecimals ? full.toFixed(2) : full;
        },
        subscribe() {
            this.$refs["product-button"].subscribe();
        }
    }
}
</script>
